// extracted by mini-css-extract-plugin
export default {"container":"Contacts_container__1rDih","heading":"Contacts_heading__lDWdZ","semibold":"Contacts_semibold__-TeNo"};